import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { resetOnLogoutReducer } from '@utils';

import {
  CustomReportsFilters,
  CustomReportsTabs,
  initialSliceState,
} from './constants';
import { CustomReportListItem } from './utils';

export const customReportsSlice = createSlice({
  name: 'customReports',
  initialState: initialSliceState,
  reducers: {
    setSorter: (
      state,
      action: PayloadAction<{
        columnKey: keyof CustomReportListItem;
        order: 'ascend' | 'descend';
      }>,
    ) => {
      const { columnKey, order } = action.payload;
      state.sorter.columnKey = columnKey;
      state.sorter.order = order;
    },
    setSelectedRowKeys: (
      state,
      action: PayloadAction<{
        items: number[];
      }>,
    ) => {
      const { items } = action.payload;
      state.selectedRowKeys = items;
    },
    setSharedReportsSelectedRowKeys: (
      state,
      action: PayloadAction<{
        items: number[];
        sharedReportUnitId: number;
      }>,
    ) => {
      const { items, sharedReportUnitId } = action.payload;
      state.sharedReportsSelectedRowKeys[sharedReportUnitId] = items;
    },
    setCustomReportsActiveTab: (
      state,
      action: PayloadAction<{
        activeTab: CustomReportsTabs;
      }>,
    ) => {
      const { activeTab } = action.payload;
      state.customReportsActiveTab = activeTab;
    },
    setSharedReportsActiveTab: (
      state,
      action: PayloadAction<{
        activeTab: string;
      }>,
    ) => {
      const { activeTab } = action.payload;
      state.sharedReportsActiveTab = activeTab;
    },
    setCustomReportsFilters: (
      state,
      action: PayloadAction<{
        unitId: string;
        payload: CustomReportsFilters;
      }>,
    ) => {
      const { payload, unitId } = action.payload;
      state.sharedUnitRecordsFilters = {
        ...state.sharedUnitRecordsFilters,
        [unitId]: payload,
      };
    },
    setSharedFilterModalOpen: (
      state,
      action: PayloadAction<{
        unitId: string;
        payload: boolean;
      }>,
    ) => {
      const { payload, unitId } = action.payload;
      state.sharedFilterModalOpen = {
        ...state.sharedFilterModalOpen,
        [unitId]: payload,
      };
    },
  },
});

const { reducer: sliceReducer, actions } = customReportsSlice;

export const {
  setSorter,
  setSelectedRowKeys,
  setSharedReportsSelectedRowKeys,
  setCustomReportsActiveTab,
  setSharedReportsActiveTab,
  setCustomReportsFilters,
  setSharedFilterModalOpen,
} = actions;

export const reducer = resetOnLogoutReducer(sliceReducer);
